'use strict';

import { util } from './util.js';
import { openAppMethod } from './openAppMethod.js';

export default (cmd, type, action, param, launchWay, callback, option) => {
    cmd = cmd ? cmd : "303";
    type = type ? type : "9";
    action = action ? action : "0";
    const timeout = 1500;
    var offtime = 2000;
    const ua = navigator.userAgent.toLocaleLowerCase();

    const isWeChat = (util.getSysBowser()[1] == 2) ? true : false;
    const isQQ = (util.getSysBowser()[1] == 3) ? true : false;
    const isWeibo = (util.getSysBowser()[1] == 4) ? true : false;
    const isIOS = (util.getSysBowser()[0] == 2 || util.getSysBowser()[0] == 3) ? true : false;
    const cannel = {
        "meipian": [809, "CK1456506087514"],
        "10004": [809, "CK1456506087514"],
        "aiting": [753, "CK1461097757899"],
        "10003": [753, "CK1461097757899"],
        "lanjingren": [753, "CK1461097757899"]
    }
    const ckey = option.aid && cannel[option.aid] && cannel[option.aid][1]
    const cid = option.aid && cannel[option.aid] && cannel[option.aid][0] ? cannel[option.aid][0] : 552
    if (option.inPartnerApp) {
        isWeChat = isQQ = isWeibo = false
    }
    function getHidden() {
        var hidden;
        if (typeof document.hidden !== "undefined") {
            hidden = "hidden";
        } else if (typeof document.mozHidden !== "undefined") {
            hidden = "mozHidden";
        } else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden";
        } else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden";
        }
        return hidden;
    }
    const mo = () => {
        openAppMethod.openByUniversalLinks(cmd, type, action, param);
        var mo_start = (new Date()).valueOf(), count = 0;
        var timer = setInterval(() => {
            count++;
            var mo_time = (new Date()).valueOf() - mo_start
            if (count >= 100 || mo_time > 3100) {
                clearInterval(timer)
                if (mo_time > 3100 || document[getHidden()]) {
                    callback && callback(true, "universalLinks")
                } else {
                    callback && callback(false, "universalLinks")
                }
            }
        }, 30)
    }
    if (isWeChat) {
        // wechat：白名单 => （Universal Links：iOS || 白名单中转链接：android）=> 弹窗提示浏览器打开
        openAppMethod.openByWeChat(cmd, type, action, param, (success) => {
            callback && callback(success, "isWeChat")
            if (success == true) {
                return
            }
            setTimeout(() => {
                if (isIOS) {
                    if (launchWay == "cmd") {
                        openAppMethod.openByWeChatWithUrl(cmd, type, action, param);
                    } else {
                        // 新版微信可以用 Universal Links 拉起了 https://mo.kugou.com/universal/
                        mo()
                        // openAppMethod.openByUniversalLinks(cmd, type, action, param);
                    }
                } else {
                    // openAppMethod.openByWeChatWithUrl(cmd, type, action, param);
                    openAppMethod.openByAndroidAppStore(cmd, type, action, param, ckey);
                }
            }, 100);
        });

    } else if (isQQ) {
        // qq：（Universal Links：iOS || 应用宝：android） => 弹窗提示
        if (isIOS) {
            if (launchWay == "cmd") {
                // QQ、weibo 不支持酷狗 SchemelUrl ，弹窗提示QQ打开
                openAppMethod.openByTips();
            } else {
                openAppMethod.openByUniversalLinks(cmd, type, action, param);
            }
        } else {
            // openAppMethod.openByAndroidAppStore(cmd, type, action, param,ckey);
            openAppMethod.openBySchemelUrl(cmd, type, action, param);
        }

        // 失败，弹窗提示浏览器打开
        setTimeout(function () {
            openAppMethod.openByTips();
        }, timeout);

    } else if (isWeibo) {
        // weibo：（Universal Links：iOS || 弹窗：android）
        if (isIOS) {
            if (launchWay == "cmd") {
                // QQ、weibo 不支持酷狗 SchemelUrl ，弹窗提示QQ打开
                openAppMethod.openByTips();
            } else {
                openAppMethod.openByUniversalLinks(cmd, type, action, param);
            }

            // 失败，弹窗提示浏览器打开
            setTimeout(function () {
                openAppMethod.openByTips();
            }, timeout);
        } else {
            // android weibo 跳转到应用宝，也拉不起客户端，弹窗提示浏览器打开
            openAppMethod.openByTips();
        }
    } else {

        if (isIOS) {
            if (launchWay == "cmd") {
                openAppMethod.openBySchemelUrl(cmd, type, action, param);
            } else {
                mo()
                // 用 Universal Links 拉起了 https://mo.kugou.com/universal/
                // openAppMethod.openByUniversalLinks(cmd, type, action, param);
            }
        } else {
            openAppMethod.openBySchemelUrl(cmd, type, action, param);
            var start = (new Date()).valueOf();
            setTimeout(function () {
                if (!document[getHidden()]) {
                    var end = (new Date()).valueOf();
                    if ((end - start) < 3050) {
                        callback && callback(false, "SchemelUrl")
                        // try {
                        //     var toast = document.createElement("div")
                        //     toast.innerHTML = "请安装酷狗后听全曲"
                        //     toast.style.cssText = [
                        //         "background:rgba(0,0,0,0.7)",
                        //         "color:#fff",
                        //         "font-size:16px",
                        //         "border-radius:5px",
                        //         "padding:10px 15px",
                        //         "position: fixed",
                        //         "top:50%",
                        //         "left:50%",
                        //         "-webkit-transform: translate(-50%, -50%)",
                        //         "transform: translate(-50%, -50%)",
                        //     ].join(";")
                        //     document.body.appendChild(toast)
                        //     setTimeout(function () {
                        //         document.body.removeChild(toast)
                        //     }, 3000)
                        // } catch (ex) {
                        // }
                        // window.location.href = "http://downmobile.kugou.com/promote/package/download/channel=" + cid
                        // openAppMethod.openByAndroidAppStore(cmd, type, action, param);
                    }
                }
            }, 3000);
        }
    }
}